var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAe = function SvgAe(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9,
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.056 3.056a2.363 2.363 0 0 1 1.671-.692h7.09c.162 0 .316.064.43.177l5.212 5.214a.606.606 0 0 1 .178.428v11.09a2.364 2.364 0 0 1-2.364 2.363H6.727a2.363 2.363 0 0 1-2.363-2.364V4.728c0-.627.249-1.229.692-1.672Zm1.671.52a1.151 1.151 0 0 0-1.151 1.152v14.544a1.152 1.152 0 0 0 1.151 1.152h10.546a1.151 1.151 0 0 0 1.151-1.152V8.434l-4.857-4.858h-6.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.71 14.926.312-1.039h1.791l.313 1.039h1.59L10.925 9.5H8.91l-1.79 5.426H8.71Zm.646-2.14.54-1.792h.043l.54 1.791H9.357ZM14.889 15c1.128 0 1.854-.54 1.992-1.388h-1.335c-.085.23-.326.36-.625.36-.435 0-.69-.286-.69-.678v-.064h2.65v-.339c0-1.295-.795-2.088-2.024-2.088-1.261 0-2.066.838-2.066 2.099 0 1.316.794 2.098 2.098 2.098Zm-.657-2.575c.008-.353.3-.594.657-.594.363 0 .638.244.646.594h-1.303Z"
  }))));
};
export default SvgAe;